export default __webpack_public_path__ + "static/media/7.46a66392.png";